export const ACCEPTABLE_FILE_TYPES = ["csv", "pdf"];
